import { Pipe, PipeTransform } from '@angular/core';
import { default as moment, Moment } from 'moment/min/moment-with-locales';

@Pipe({
    name: 'timeAgoPipe',
    pure: false,
})
export class TimeAgoPipe implements PipeTransform {
    transform(value?: string | Date | null): string {
        if (value !== undefined && value != null) {
            const lang = localStorage.getItem('lang') ?? false;
            const momentObj = moment(value);
            return momentObj.locale(lang).fromNow();
        }
        return '';
    }
}
